import { AclosetApiWrapper } from './AclosetApiWrapper';
import { AclosetHttpClient } from './AclosetHttpClient';

/**
 * Swagger 기반의 API 서비스.
 */
export const aclosetApi = new AclosetApiWrapper(new AclosetHttpClient());
